export const HANDSFREE_POPUP_AUTO_CLOSE_MS = 20_000;

interface AutoCloseInput {
  isPopupOpen: boolean;
  isSpeaking: boolean;
  isHovering: boolean;
  isConversationOver: boolean;
}

export function shouldScheduleHandsFreePopupAutoClose({
  isPopupOpen,
  isSpeaking,
  isHovering,
  isConversationOver,
}: AutoCloseInput): boolean {
  return isPopupOpen && !isSpeaking && !isHovering && !isConversationOver;
}

export function isAiSpeechStart(
  previousPlayingId: string | null,
  currentPlayingId: string | null
): boolean {
  return previousPlayingId === null && currentPlayingId !== null;
}

export function isEmbeddedScreenFocusTarget(element: Element | null): boolean {
  return element instanceof HTMLIFrameElement;
}
